import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import ListLivestreamRegistered, { Header } from '../../pages/LivestreamRegisteredManagementViewer/ListLivestreamRegistered';
import {
    ViewerGetListLivestreamRegisteredRequested,
    ViewerClearListLivestreamRegistered,
} from '../../actions/LiveStreamManagement';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    isLoading: state.livestream.getListLivestreamRegisteredViewer.isFetching || state.adminSettingCustom.getCustomText.isFetching,
    listRegistered: state.livestream.getListLivestreamRegisteredViewer.listRegistered,
    listLivestream: state.livestream.getListLivestreamRegisteredViewer?.data,
    eventInfo: state.registration.registrationViewer.data,
    customText: state.adminSettingCustom.getCustomText.data?.content,
    customColor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
});

const mapDispatchToProps = (dispatch) => ({
    getListRegisteredLivestream: (params) => {
        dispatch(ViewerGetListLivestreamRegisteredRequested(params));
    },
    clearListRegisteredLivestream: () => {
        dispatch(ViewerClearListLivestreamRegistered());
    },
});

export const ListLivestreamRegisteredHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListLivestreamRegistered);
